import React, { Suspense } from 'react'
import { connect } from 'react-redux'
import { withTranslation, WithTranslation } from '../i18n'
import { RootState } from '../redux/types'
import { accessTokenSelector } from '../redux/auth/authSelectors'
import { credentialsLogInRequest, logOut } from '../redux/auth/authActions'
import { getAppDataRequest } from '../redux/data/dataActions'

type ReduxProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps
interface Props extends ReduxProps, WithTranslation {}

class App extends React.Component<Props> {
  render() {
    const { accessToken, logOut } = this.props

    return (
      <div style={{ marginLeft: 30 }}>
        <p>{`Token: ${accessToken}`}</p>
        <button style={{ padding: 10 }} onClick={logOut}>
          Logout
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  accessToken: accessTokenSelector(state),
})

const mapDispatchToProps = {
  credentialsLogInRequest,
  getAppDataRequest,
  logOut,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(App))
